module.exports = __webpack_public_path__ + "img/icon-cardgames-black.2a53fbb6.svg";